<div class="main-div">
<mat-spinner
  *ngIf="loading"
  class="loading"
  diameter="50"
></mat-spinner>
<div class="score-area-root" *ngIf="!loading">
  <div class="left">
    <div class="business-data">
      <app-rounded-image xsmall [src]="topHeaderService.business?.imgSource"></app-rounded-image>
      <span class="business-name">{{topHeaderService.business?.businessName}}</span>
    </div>
  </div>
  <div class="right">
    <div class="points-info" *ngIf="topHeaderService.businessSummary?.pointsByFamily?.length">
      <div class="points-added" *ngFor="let item of topHeaderService.businessSummary?.pointsByFamily | slice:0:1">
        <div class="points">{{ item.pointSummary?.totalPoints || 0 }}<mat-icon class="icon">stars</mat-icon></div>
        <div class="label">{{ labels.totalPointsFor }} {{ item.family?.name }} {{ labels.series }}</div>
      </div>
      <div
        class="points-added show-more-btn"
        *ngIf="topHeaderService.businessSummary!.pointsByFamily.length > 1"
        (click)="navigateToPointsDetail()"
      >
        <div class="points">
          <mat-icon>add</mat-icon>
        </div>
        <div class="label">{{ labels.showMore }}</div>
      </div>
    </div>
  </div>
</div>
</div>
